import { Icon } from "@material-ui/core";
import * as React from "react";

import styles from "./HorizontalCardAttachment.scss";

interface IProps {
    fileUrl: string;
}

const HorizontalCardAttachment: React.FunctionComponent<IProps> = (props: IProps) => {
    // Get filename and add optional whitelines (for word breaks)
    const pathParts = props.fileUrl.split("/");
    const fileName = pathParts[pathParts.length - 1]
        .replace(/([\-\.\_]+)/g, "$1\n")
        .split("\n")
        .map((part, i) => <span key={i}>{part}<wbr/></span>);
    
    return (
        <div className={styles.cardAttachment}>
            <div className={styles.content}>
                <Icon className={styles.icon}>attach_file</Icon>
                <div>{fileName}</div>
            </div>
        </div>
    );
};

export default HorizontalCardAttachment;


// WEBPACK FOOTER //
// ./src/Components/Common/HorizontalCardGrid/HorizontalCard/HorizontalCardAttachment/HorizontalCardAttachment.tsx